import { defineStore } from "pinia"

export const useUserStore = defineStore("user", {
  state: () => ({
    acceptedTerms: false,
    seenLandingPage: false,
    email: "",
    tempToken: "",
    bearerToken: ""
  }),
  actions: {
    setAcceptedTerms(status: boolean) {
      this.acceptedTerms = status
    },
    setSeenLandingPage(status: boolean) {
      this.seenLandingPage = status
    },
    setEmail(email: string) {
      this.email = email
    },
    setTempToken(token: string) {
      this.tempToken = token
    },
    setBearerToken(token: string) {
      this.bearerToken = token
    }
  }
})
